import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <header
            id="hero"
            className="hero-section"
            style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/engagement/VK-27.jpg)` }}
        >
            <div className="hero-overlay"></div>
            <div className="hero-content">
                <h1>Vanessa & Kay</h1>
                <p className="hero-date">October 10, 2026</p>
                <p className="hero-location">Hackettstown, New Jersey</p>
                <a href="#rsvp" className="btn hero-btn">RSVP Now</a>
            </div>
        </header>
    );
};

export default Hero;
